__turbopack_context__.v({
  "bottomSheet": "PackCard-module__abQe2q__bottomSheet",
  "pricingInfo": "PackCard-module__abQe2q__pricingInfo",
  "ringSpec": "PackCard-module__abQe2q__ringSpec",
  "root": "PackCard-module__abQe2q__root",
  "stepFadeIn": "PackCard-module__abQe2q__stepFadeIn",
});
